/*
 * @Author: yanzheng 1477388171@qq.com
 * @Date: 2022-12-16 17:47:11
 * @LastEditors: xuiang 1477388171@QQ.com
 * @LastEditTime: 2023-02-25 18:45:55
 * @FilePath: \wjp_pcqhf_web_vue3\static\base-url.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
let baseUrl = {
  snxmym: {
    // apiUrl: 'http://125.35.8.37:9797/tyxttj_test/api/v1', // 远程机
    // login: 'http://125.35.8.37:9797/tyxttj_test' // 远程机
    // apiUrl: 'http://192.168.11.58:8001/tyxttj/api/v1', // 何润东本地
    // login: 'http://192.168.11.58:8001/tyxttj' // 何润东本地
    apiUrl: 'http://125.35.8.37:9797/tyxttj/api/v1',
    login: 'http://125.35.8.37:9797/tyxttj'
  },
  //测试环境
  sncs: {
    apiUrl: 'http://172.16.101.20:9030/xttj_test/api/v1',
    // apiUrl: 'http://192.168.11.131:8001/tyxttj/api/v1', // hsz本地
    // apiUrl: 'http://192.168.11.54:8001/tyxttj/api/v1', // zhj本地
    login: 'http://172.16.101.20:9030/xttj'
  },
  // 内网
  snxmnw: {
    apiUrl: 'http://172.16.100.157:9080/tyxttj/api/v1',
    login: 'http://172.16.100.157:9080/tyxttj'
  },
  // 体育总局内网
  tyjnw: {
    apiUrl: 'http://192.168.11.77:8001/tyxttj/api/v1',
    login: 'http://192.168.11.77:8001/tyxttj/'
  },
  // 体育总局公网
  tyjgw: {
    apiUrl: 'http://125.35.8.37:9797/tyxttj/api/v1',
    login: 'http://125.35.8.37:9797/'
  }
}
let ENV =
  window.location.hostname.includes('172.16.101.20') ||
  window.location.hostname.includes('localhost') ||
  window.location.hostname.includes('xtgc.geo-compass.com')
    ? 'sncs'
    : window.location.hostname.includes('192.168.11.61')
    ? 'snxmym'
    : window.location.hostname.includes('125.35.8.37')
    ? 'tyjgw'
        : 'sncs'
let hostname = window.location.hostname
//国家局外网
let TdtUrls_test = [
  'https://t0.tianditu.gov.cn',
  'https://t1.tianditu.gov.cn',
  'https://t2.tianditu.gov.cn',
  'https://t3.tianditu.gov.cn',
  'https://t4.tianditu.gov.cn',
  'https://t5.tianditu.gov.cn',
  'https://t6.tianditu.gov.cn',
  'https://t7.tianditu.gov.cn'
]
let CONFIG = {
  //地图地址判断
  drawMapStyle: '/static/lib/jsDoc/drawMapStyle.json',
  TdtUrls: TdtUrls_test
}
// 各省地图添加
CONFIG.img_wmts = {}
export { baseUrl, CONFIG, ENV }
